import React, {Component} from 'react';
import {
    Platform,
    View,
    FlatList,
    TouchableOpacity,
} from 'react-native';
import i18n from '../../I18n/i18n';
import {moderateScale} from '../../tools/Scaling';
import PathFile from '../../assets/PathFile';
import Colors from '../../tools/Colors';

import HMTextView from '../HMTextView';
import HMIcon from '../HMIcon';
import {typeExport} from '../../redux/store/type';
import HMLightbox from '../lightbox/HMLightbox';

import HMModalSelectFiles from '../selectFiles/HMModalSelectFiles';
import HMRecordAudio from '../record/audio/HMRecordAudio';
import HMLabel from '../label/HMLabel';
import {Tools} from '../../tools/Tools';
import HMVoicePlayer from '../voice/HMVoicePlayer';

var container = null;

export default class HMFilesTest extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {
            min: null,
            max: null,
            size: null,

            Modalcategory: false,
            pickedcategory: null,

            visibleCategoryType: false,
            pickedCategoryType: null,

            visibleModal: '',

            ShowImage: props.pathImages || (props.stateParent && props.stateParent.pathImage),
            ShowVideo: props.pathVideo || (props.stateParent && props.stateParent.pathVideo),
            ShowAudio: props.pathAudio || (props.stateParent && props.stateParent.ShowAudio),

            pathImage: null,
            pathImageVideo: PathFile.image.PlayVideo,
            pathVideo: props.pathVideo ? props.pathVideo : null,
            //    audioPath: props.stateParent && props.stateParent.audioPath ? props.stateParent.audioPath : AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            audioPath: props.pathAudio ? props.pathAudio : null,

            index: 0,

            checked: false,
            pathCompress: null,


            currentTime: props.currentTime ? props.currentTime : 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            //   audioPath: AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            //   audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            arrImage: props.pathImages ? props.pathImages : (props.stateParent && props.stateParent.arrImage ? props.stateParent.arrImage : []),
            arrFile: props.patharrFiles ? props.patharrFiles : (props.stateParent && props.stateParent.arrFile ? props.stateParent.arrFile : []),
            // arrImage: [1, 2, 3, 4, 5, 6],
            alaki: false,
        };
        this.recorderRef = React.createRef(null);

    }

    async componentDidMount() {


    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
        // if (sound && Platform.OS !== "web") {
        //     sound.release();
        //     sound = null;
        // }
        if (this.timeout) {
            clearInterval(this.timeout);
        }
    }


    handleScroll(event) {
    }

    _onRef = (property, view) => {
        this[property] = view;
    };

    hiddenModal(func = null) {
        func ? func() : null;
        container.setState({
                visibleModal: '',
            },
            async () => {
                // this.state.recording?   await this._stopWeb():null
            },
        );
    }


    async onShow(data, func) {
        func ? func() : null;
        // if (data === 'selectaudio') {
        //     this.setState({
        //         visibleModal: data,
        //         Modalcategory: true,
        //         //    audioPath: p,
        //     });
        //
        // }
        // else
        container.setState({
            visibleModal: data,
            Modalcategory: true,
            //    audioPath: p,
        });
    }


    render() {
        let width_item = Platform.OS == 'web' ? moderateScale(300) : typeExport.WIDTH;

        let optional = (Platform.OS === 'ios' ? {
            //compressImageMaxWidth: Platform.OS==='ios'?10000:1000,
            //  compressImageMaxHeight: Platform.OS==='ios'?10000:1000,
            enableRotationGesture: true,
            // cropping: true,
            compressImageQuality: .5,
        } : {
            compressImageMaxWidth: 1000,
            compressImageMaxHeight: 1000,
            enableRotationGesture: true,
            cropping: true,
            // compressImageQuality:.5
        });

        const CustomView = Platform.OS === 'web' ? View : TouchableOpacity;
        const {onPress, styleRoot, styleRoot2, style, text, numberOfLines, type, cammas, noFont, SizeBox = 2, onlyShow, notFirstClear} = this.props;
        const renderAddImage = () => {

            return <View
                style={{
                    //  backgroundColor: '#5b51ee',
                    backgroundColor: Colors.white,
                    height: moderateScale(240 / SizeBox),
                    width: moderateScale(280 / SizeBox),

                    //  paddingLeft:10,
                    // marginBottom:10,
                    borderStyle: 'dashed',
                    borderRadius: moderateScale(1),
                    borderWidth: moderateScale(1),
                    borderColor: Colors.colorPrimary,
                    //    borderTopColor: 'white',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginEnd: moderateScale(4),
                    overflow: 'hidden',
                    padding: moderateScale(2),
                    flexDirection: 'row',
                    alignSelf: 'center',

                }}>
                <CustomView
                    //  disabled={Platform.OS === 'web'}

                    onPress={() => {
                        this.onShow('selectImage');

                        //this.setState({ShowImage: true})
                    }}

                    style={{

                        //  position: 'absolute',
                        // paddingVertical: moderateScale(10),
                        // //backgroundColor: '#96a7ee',
                        //  width: moderateScale(40),
                        // height: moderateScale(40),
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <HMIcon name={'md-images'} style={{
                        width: moderateScale(80 / SizeBox),
                        height: moderateScale(80 / SizeBox),
                        textAlign: 'center',
                        //alignSelf: 'flex-end',
                        color: Colors.gray,
                        //width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(80 / SizeBox),
                    }}/>

                    <HMTextView
                        text={i18n.t('constant.Add_photo')}
                        style={{
                            alignSelf: 'center',
                            //  marginRight: moderateScale(6),
                            // margin: moderateScale(6),
                            textAlign: 'center',
                            color: Colors.colorDarkText,
                            fontSize: moderateScale(30 / SizeBox),
                        }}/>

                    {
                        Platform.OS === 'web' ? <HMLabel
                            onClick={() => {
                                this.setState({
                                    showMessageInput: false,
                                });
                            }}
                            onChange={(event) => this.fileSelect(event)}

                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: .009,
                            }}
                            type="file" accept="image/*"
                        /> : null

                    }
                </CustomView>
            </View>;
            //  onlyShow ? null :

        };
        const renderAddFile = () => {

            return <View
                style={{
                    //  backgroundColor: '#5b51ee',
                    backgroundColor: Colors.white,
                    height: moderateScale(240 / SizeBox),
                    width: moderateScale(280 / SizeBox),

                    //  paddingLeft:10,
                    // marginBottom:10,
                    borderStyle: 'dashed',
                    borderRadius: moderateScale(1),
                    borderWidth: moderateScale(1),
                    borderColor: Colors.colorPrimary,
                    //    borderTopColor: 'white',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginEnd: moderateScale(4),
                    overflow: 'hidden',
                    padding: moderateScale(2),
                    flexDirection: 'row',
                    alignSelf: 'center',

                }}>
                <CustomView
                    //  disabled={Platform.OS === 'web'}

                    onPress={() => {
                        this.onShow('selectImage');

                        //this.setState({ShowImage: true})
                    }}

                    style={{

                        //  position: 'absolute',
                        // paddingVertical: moderateScale(10),
                        // //backgroundColor: '#96a7ee',
                        //  width: moderateScale(40),
                        // height: moderateScale(40),
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <HMIcon name={'md-attach'} style={{
                        width: moderateScale(80 / SizeBox),
                        height: moderateScale(80 / SizeBox),
                        textAlign: 'center',
                        //alignSelf: 'flex-end',
                        color: Colors.gray,
                        //width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(80 / SizeBox),
                    }}/>

                    <HMTextView
                        // text={i18n.t('constant.Add_file')}
                        text={'افزودن فایل'}
                        style={{
                            alignSelf: 'center',
                            //  marginRight: moderateScale(6),
                            // margin: moderateScale(6),
                            textAlign: 'center',
                            color: Colors.colorDarkText,
                            fontSize: moderateScale(30 / SizeBox),
                        }}/>

                    {
                        Platform.OS === 'web' ? <HMLabel
                            onClick={() => {
                                this.setState({
                                    showMessageInput: false,
                                });
                            }}
                            onChange={(event) => this.fileSelect(event)}

                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: .009,
                            }}
                            type="file" accept=".doc,.docx,.xml,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
text/plain, application/pdf"
                        /> : null

                    }
                </CustomView>
            </View>;
            //  onlyShow ? null :

        };
        return (
            <View style={[styleRoot, {flex: 1, padding: moderateScale(20)}]}>

                <View style={[{width: '100%'}, styleRoot2 ? styleRoot2 : {}]}>
                    {
                        this.state.arrImage && this.state.arrImage.length > 0 ?
                            <View
                                style={[

                                    {flexDirection: 'row', width: '100%', marginVertical: moderateScale(6)}]}>
                                {
                                    renderAddImage()
                                }

                                {
                                    // this.state.arrImage && this.state.arrImage.length > 0 ?
                                    //     this.state.arrImage.map((item, index) => {
                                    //         item = Platform.OS === "web" ? URL.createObjectURL(item) : item;
                                    //
                                    //         return <View
                                    //             style={{
                                    //                 // backgroundColor: index % 2 === 0 ? '#30ee00' : '#ee0510',
                                    //                 height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                    //                 width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                    //                 marginHorizontal: moderateScale(6 / SizeBox)
                                    //             }}>
                                    //
                                    //             <View style={{
                                    //                 position: 'relative',
                                    //                 //backgroundColor: '#eeba0d',
                                    //                 width: "100%",
                                    //                 height: "100%"
                                    //             }}>
                                    //
                                    //
                                    //                 <HMLightbox uri={item}/>
                                    //                 <TouchableOpacity
                                    //                     onPress={() => {
                                    //                         this.state.arrImage.splice(index, 1)
                                    //                         this.setState({
                                    //                             alaki: !this.state.alaki
                                    //                         }, () => {
                                    //                             //    this.props.func("arrImage", this.state.arrImage)
                                    //                             this.props._setStateData?.({arrImage: this.state.arrImage})
                                    //                             this.props._setStateDataParent?.({arrImage: this.state.arrImage})
                                    //                         })
                                    //
                                    //
                                    //                         //this.setState({ShowImage: false})
                                    //                         //  this.setState({pathImage: null,})
                                    //                         // this.onShow("SelectModal")
                                    //                     }}
                                    //
                                    //                     style={{
                                    //                         width: moderateScale(52 / SizeBox),
                                    //                         height: moderateScale(52 / SizeBox),
                                    //                         backgroundColor: '#ee005b',
                                    //                         position: 'absolute',
                                    //                         borderRadius: moderateScale(26 / SizeBox),
                                    //                         margin: moderateScale(2),
                                    //                         top: 0,
                                    //                         left: 0,
                                    //                         alignItems: 'center',
                                    //                         justifyContent: 'center'
                                    //                     }}>
                                    //
                                    //                     <HMIcon name={"remove"}
                                    //
                                    //
                                    //                             style={{
                                    //                                 textAlign: 'center',
                                    //                                 //alignSelf: 'flex-end',
                                    //                                 color: Colors.white,
                                    //                                 // width: moderateScale(32),
                                    //                                 // height: moderateScale(32),
                                    //                                 fontSize: moderateScale(44 / SizeBox)
                                    //                             }}/>
                                    //                 </TouchableOpacity>
                                    //             </View>
                                    //
                                    //         </View>
                                    //     })
                                    //     :
                                    //     null
                                }
                                <FlatList
                                    keyboardShouldPersistTaps="handled"
                                    // ItemSeparatorComponent={
                                    //     <View style={{
                                    //         width: '100%',
                                    //         height: moderateScale(1),
                                    //         backgroundColor: '#4f4f4f'
                                    //     }}/>
                                    // }

                                    style={{
                                        // width:"100%"
                                        //  backgroundColor: Colors.yellow,
                                        //   marginBottom: moderateScale(50)
                                    }}
                                    horizontal
                                    pagingEnabled={true}
                                    //  showsHorizontalScrollIndicator={false}
                                    //  legacyImplementation={false}
                                    //data={this.state.listSearch}
                                    data={this.state.arrImage}
                                    //data={dataList}
                                    keyExtractor={(item, index) => item.id}
                                    inverted={Platform.OS === 'android' && i18n.locale == 'fa'}

                                    renderItem={

                                        ({item, index}) => {
                                            //item = null;
                                            item = item ? (Platform.OS === 'web' && !onlyShow ? URL.createObjectURL(item) : item) : null;

                                            return <View
                                                style={{
                                                    // backgroundColor: index % 2 === 0 ? '#30ee00' : '#ee0510',
                                                    height: width_item / SizeBox - moderateScale(60 / SizeBox),
                                                    width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                                    marginHorizontal: moderateScale(6 / SizeBox),
                                                }}>

                                                <View style={{
                                                    position: 'relative',
                                                    //backgroundColor: '#eeba0d',
                                                    width: '100%',
                                                    height: '100%',
                                                }}>


                                                    <HMLightbox uri={item}/>
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            this.state.arrImage.splice(index, 1);
                                                            this.setState({
                                                                alaki: !this.state.alaki,
                                                            }, () => {
                                                                //    this.props.func("arrImage", this.state.arrImage)
                                                                this.props._setStateData?.({arrImage: this.state.arrImage});
                                                                this.props._setStateDataParent?.({arrImage: this.state.arrImage});
                                                            });


                                                            //this.setState({ShowImage: false})
                                                            //  this.setState({pathImage: null,})
                                                            // this.onShow("SelectModal")
                                                        }}

                                                        style={{
                                                            width: moderateScale(52 / SizeBox),
                                                            height: moderateScale(52 / SizeBox),
                                                            backgroundColor: '#ee005b',
                                                            position: 'absolute',
                                                            borderRadius: moderateScale(26 / SizeBox),
                                                            margin: moderateScale(2),
                                                            top: 0,
                                                            left: 0,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}>

                                                        <HMIcon name={'remove'}


                                                                style={{
                                                                    textAlign: 'center',
                                                                    //alignSelf: 'flex-end',
                                                                    color: Colors.white,
                                                                    // width: moderateScale(32),
                                                                    // height: moderateScale(32),
                                                                    fontSize: moderateScale(44 / SizeBox),
                                                                }}/>
                                                    </TouchableOpacity>
                                                </View>

                                            </View>;
                                        }

                                    }
                                />
                            </View>
                            :
                            renderAddImage()
                    }

                    {


                        Platform.OS === 'web' && (this.state.arrFile && this.state.arrFile.length > 0 ?
                                <View
                                    style={[

                                        {flexDirection: 'row', width: '100%', marginVertical: moderateScale(6)}]}>
                                    {
                                        renderAddFile()
                                    }

                                    {
                                        // this.state.arrImage && this.state.arrImage.length > 0 ?
                                        //     this.state.arrImage.map((item, index) => {
                                        //         item = Platform.OS === "web" ? URL.createObjectURL(item) : item;
                                        //
                                        //         return <View
                                        //             style={{
                                        //                 // backgroundColor: index % 2 === 0 ? '#30ee00' : '#ee0510',
                                        //                 height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                        //                 width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                        //                 marginHorizontal: moderateScale(6 / SizeBox)
                                        //             }}>
                                        //
                                        //             <View style={{
                                        //                 position: 'relative',
                                        //                 //backgroundColor: '#eeba0d',
                                        //                 width: "100%",
                                        //                 height: "100%"
                                        //             }}>
                                        //
                                        //
                                        //                 <HMLightbox uri={item}/>
                                        //                 <TouchableOpacity
                                        //                     onPress={() => {
                                        //                         this.state.arrImage.splice(index, 1)
                                        //                         this.setState({
                                        //                             alaki: !this.state.alaki
                                        //                         }, () => {
                                        //                             //    this.props.func("arrImage", this.state.arrImage)
                                        //                             this.props._setStateData?.({arrImage: this.state.arrImage})
                                        //                             this.props._setStateDataParent?.({arrImage: this.state.arrImage})
                                        //                         })
                                        //
                                        //
                                        //                         //this.setState({ShowImage: false})
                                        //                         //  this.setState({pathImage: null,})
                                        //                         // this.onShow("SelectModal")
                                        //                     }}
                                        //
                                        //                     style={{
                                        //                         width: moderateScale(52 / SizeBox),
                                        //                         height: moderateScale(52 / SizeBox),
                                        //                         backgroundColor: '#ee005b',
                                        //                         position: 'absolute',
                                        //                         borderRadius: moderateScale(26 / SizeBox),
                                        //                         margin: moderateScale(2),
                                        //                         top: 0,
                                        //                         left: 0,
                                        //                         alignItems: 'center',
                                        //                         justifyContent: 'center'
                                        //                     }}>
                                        //
                                        //                     <HMIcon name={"remove"}
                                        //
                                        //
                                        //                             style={{
                                        //                                 textAlign: 'center',
                                        //                                 //alignSelf: 'flex-end',
                                        //                                 color: Colors.white,
                                        //                                 // width: moderateScale(32),
                                        //                                 // height: moderateScale(32),
                                        //                                 fontSize: moderateScale(44 / SizeBox)
                                        //                             }}/>
                                        //                 </TouchableOpacity>
                                        //             </View>
                                        //
                                        //         </View>
                                        //     })
                                        //     :
                                        //     null
                                    }
                                    <FlatList
                                        keyboardShouldPersistTaps="handled"
                                        // ItemSeparatorComponent={
                                        //     <View style={{
                                        //         width: '100%',
                                        //         height: moderateScale(1),
                                        //         backgroundColor: '#4f4f4f'
                                        //     }}/>
                                        // }

                                        style={{
                                            // width:"100%"
                                            //  backgroundColor: Colors.yellow,
                                            //   marginBottom: moderateScale(50)
                                        }}
                                        horizontal
                                        pagingEnabled={true}
                                        //  showsHorizontalScrollIndicator={false}
                                        //  legacyImplementation={false}
                                        //data={this.state.listSearch}
                                        data={this.state.arrFile}
                                        //data={dataList}
                                        keyExtractor={(item, index) => item.id}
                                        inverted={Platform.OS === 'android' && i18n.locale == 'fa'}

                                        renderItem={

                                            ({item, index}) => {
                                                //item = null;
                                                item = item ? (Platform.OS === 'web' && !onlyShow ? URL.createObjectURL(item) : item) : null;

                                                return <View
                                                    style={{
                                                        // backgroundColor: index % 2 === 0 ? '#30ee00' : '#ee0510',
                                                        height: width_item / SizeBox - moderateScale(60 / SizeBox),
                                                        width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                                        marginHorizontal: moderateScale(6 / SizeBox),
                                                    }}>

                                                    <View style={{
                                                        position: 'relative',
                                                        //backgroundColor: '#eeba0d',
                                                        width: '100%',
                                                        height: '100%',
                                                    }}>


                                                        <TouchableOpacity
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                backgroundColor: Colors.blackLight,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}
                                                            onPress={() => {
                                                                Tools.GoLink(item);
                                                            }}
                                                        >
                                                            <HMIcon name={'md-attach'} style={{
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: Colors.white,
                                                                // width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(160 / SizeBox),
                                                            }}/>
                                                        </TouchableOpacity>
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                this.state.arrFile.splice(index, 1);
                                                                this.setState({
                                                                    alaki: !this.state.alaki,
                                                                }, () => {
                                                                    //    this.props.func("arrFile", this.state.arrFile)
                                                                    this.props._setStateData?.({arrFile: this.state.arrFile});
                                                                    this.props._setStateDataParent?.({arrFile: this.state.arrFile});
                                                                });


                                                                //this.setState({ShowImage: false})
                                                                //  this.setState({pathImage: null,})
                                                                // this.onShow("SelectModal")
                                                            }}

                                                            style={{
                                                                width: moderateScale(52 / SizeBox),
                                                                height: moderateScale(52 / SizeBox),
                                                                backgroundColor: '#ee005b',
                                                                position: 'absolute',
                                                                borderRadius: moderateScale(26 / SizeBox),
                                                                margin: moderateScale(2),
                                                                top: 0,
                                                                left: 0,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}>

                                                            <HMIcon name={'remove'}


                                                                    style={{
                                                                        textAlign: 'center',
                                                                        //alignSelf: 'flex-end',
                                                                        color: Colors.white,
                                                                        // width: moderateScale(32),
                                                                        // height: moderateScale(32),
                                                                        fontSize: moderateScale(44 / SizeBox),
                                                                    }}/>
                                                        </TouchableOpacity>
                                                    </View>

                                                </View>;
                                            }

                                        }
                                    />
                                </View>
                                :
                                renderAddFile()
                        )
                    }

                    <View
                        style={[styleRoot2 ? {} : {
                            width: '100%',
                        }, {
                            //  backgroundColor: "#eece01",
                            marginHorizontal: moderateScale(8),
                            alignItems: 'center',
                            justifyContent: 'center',

                            flexDirection: 'row',
                            // alignSelf: 'center',
                            marginVertical: moderateScale(6),

                        }]}>


                        <View

                            style={{
                                width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                //height: "100%",
                                padding: moderateScale(4),
                                borderWidth: moderateScale(1),
                                borderRadius: moderateScale(2),
                                borderColor: '#ddd',
                                borderBottomWidth: 0,
                                shadowColor: '#000',
                                shadowOffset: {width: 0, height: moderateScale(.8)},
                                shadowOpacity: 0.6,
                                shadowRadius: moderateScale(2),
                                elevation: moderateScale(1),
                                marginLeft: moderateScale(1),
                                marginRight: moderateScale(1),
                                marginTop: moderateScale(1),
                                marginBottom: moderateScale(1),
                                backgroundColor: Colors.white,
                                alignItems: 'center',
                                justifyContent: 'center',

                            }}>


                            <View
                                onPress={() => {
                                    // this.onShow("selectaudio")
                                    //this.setState({ShowImage: true})
                                }}

                                style={{

                                    //  width: "100%",
                                    //  height: "100%",
                                    position: 'absolute',
                                    // paddingVertical: moderateScale(10 / SizeBox),
                                    //backgroundColor: '#96a7ee',
                                    //  width: moderateScale(40),
                                    // height: moderateScale(40),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: this.state.ShowAudio ? 0 : 1,
                                    opacity: this.state.ShowAudio ? 0 : 1,
                                }}

                            >
                                <HMRecordAudio
                                    //  ref={ref => (this.recorderRef = ref)}
                                    ref={this.recorderRef}
                                    onShow={this.onShow}
                                    hiddenModal={this.hiddenModal}
                                    // setData={this.setData}
                                    _setStateData={this._setStateData}
                                    _setStateDataParent={this.props._setStateData}
                                    clearState={this.props.clearState}
                                    notFirstClear={notFirstClear}
                                    showTime
                                    // styleIcon={{
                                    //     width: moderateScale(30 ),
                                    //     height: moderateScale(30 ),
                                    //     color:Colors.gray,fontSize:moderateScale(30)
                                    // }}
                                    fontSizeIcon={30}
                                    colorIcon={Colors.gray}
                                    style={{
                                        width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                        height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                        margin: 0,
                                    }}

                                />


                            </View>
                            <View
                                style={{
                                    position: 'relative',
                                    //backgroundColor: '#eeba0d',
                                    width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                    height: width_item / SizeBox - moderateScale(90 / SizeBox),

                                    zIndex: this.state.ShowAudio ? 1 : 0,
                                    opacity: this.state.ShowAudio ? 1 : 0,

                                }}>

                                <View
                                    onPress={() => {
                                        this.setState(
                                            {
                                                playState: 'paused',
                                                visibleModal: 'selectaudio',
                                                Modalcategory: true,
                                            },
                                            () => {
                                                // this.onShow("selectaudio")

                                                this._play();

                                            },
                                        );
                                    }}
                                    style={{
                                        // width: "100%",
                                        //height: "100%",
                                        //resizeMode: 'contain'
                                        //
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.blackLight,
                                    }}>
                                    <HMVoicePlayer styleTime={{color: Colors.white}} styleIcon={{}}
                                                   style={{color: Colors.white}}
                                                   path={this.state.audioPath}
                                                   durationDynamic={this.state.durationVoice}
                                    />

                                </View>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  console.log("this.recorderRef.current", this.recorderRef.current)
                                        Platform.OS === 'web' ? this.recorderRef.current._refreshAudio() : this.recorderRef.current._refreshAudio();
                                        // this.setState({audioPath: null,})
                                        // this.onShow("SelectModal")
                                    }}

                                    style={{
                                        width: moderateScale(64 / SizeBox),
                                        height: moderateScale(64 / SizeBox),
                                        backgroundColor: '#ee005b',
                                        position: 'absolute',
                                        borderRadius: moderateScale(32 / SizeBox),
                                        margin: moderateScale(4),
                                        top: 0,
                                        left: 0,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    <HMIcon name={'remove'} style={{
                                        textAlign: 'center',
                                        //alignSelf: 'flex-end',
                                        color: Colors.white,
                                        // width: moderateScale(32),
                                        // height: moderateScale(32),
                                        fontSize: moderateScale(44 / SizeBox),
                                    }}/>
                                </TouchableOpacity>
                            </View>


                        </View>


                        <View
                            style={{width: moderateScale(4)}}/>
                        {

                            // Platform.OS === "web" ?
                            // null
                            // :
                            <View


                                style={{
                                    width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                    padding: moderateScale(4),
                                    borderWidth: moderateScale(1),
                                    borderRadius: moderateScale(2),
                                    borderColor: '#ddd',
                                    borderBottomWidth: 0,
                                    shadowColor: '#000',
                                    shadowOffset: {width: 0, height: moderateScale(.8)},
                                    shadowOpacity: 0.6,
                                    shadowRadius: moderateScale(2),
                                    elevation: moderateScale(1),
                                    marginLeft: moderateScale(1),
                                    marginRight: moderateScale(1),
                                    marginTop: moderateScale(1),
                                    marginBottom: moderateScale(1),
                                    backgroundColor: Colors.white,
                                }}>
                                {/*    <Card>
                                <CardItem cardBody style={{
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    alignItems: 'center', justifyContent: 'center'
                                }}>*/}
                                <View
                                    style={{
                                        position: 'relative',
                                        paddingVertical: moderateScale(10),
                                        height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >

                                    {
                                        this.state.ShowVideo ?
                                            <View
                                                style={{
                                                    position: 'relative',
                                                    //backgroundColor: '#eeba0d',
                                                    width: width_item / SizeBox - moderateScale(20 / SizeBox),
                                                    height: width_item / SizeBox - moderateScale(90 / SizeBox),
                                                }}>

                                                <HMLightbox
                                                    pathVideo={this.state.pathVideo ? (Platform.OS === 'web' && !onlyShow ? URL.createObjectURL(this.state.pathVideo) : this.state.pathVideo) : null}
                                                    source_image={this.state.pathImageVideo} type={'video'}
                                                />


                                                <TouchableOpacity
                                                    onPress={() => {
                                                        this.setState({ShowVideo: false});
                                                        //this.props.func("pathVideo", null)
                                                        this.props._setStateData?.({pathVideo: null});
                                                        this.props._setStateDataParent?.({pathVideo: null});

                                                    }}

                                                    style={{
                                                        width: moderateScale(64 / SizeBox),
                                                        height: moderateScale(64 / SizeBox),
                                                        backgroundColor: '#ee005b',
                                                        position: 'absolute',
                                                        borderRadius: moderateScale(32 / SizeBox),
                                                        margin: moderateScale(4),
                                                        top: 0,
                                                        left: 0,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}>
                                                    <HMIcon name={'remove'} style={{
                                                        textAlign: 'center',
                                                        //alignSelf: 'flex-end',
                                                        color: Colors.white,
                                                        // width: moderateScale(32),
                                                        // height: moderateScale(32),
                                                        fontSize: moderateScale(44 / SizeBox),
                                                    }}/>
                                                </TouchableOpacity>
                                            </View>
                                            :
                                            <TouchableOpacity
                                                // disabled={Platform.OS === "web"}

                                                onPress={() => {
                                                    this.onShow('selectVideo');

                                                    //this.setState({ShowImage: true})
                                                }}
                                                style={{

                                                    paddingVertical: moderateScale(20 / SizeBox),
                                                    //backgroundColor: '#96a7ee',
                                                    //  width: moderateScale(40),
                                                    //height: moderateScale(40),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >

                                                <HMIcon name={'md-videocam'} style={{
                                                    width: moderateScale(80 / SizeBox),
                                                    height: moderateScale(80 / SizeBox),
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.gray,
                                                    // width: moderateScale(32),
                                                    // height: moderateScale(32),
                                                    fontSize: moderateScale(80 / SizeBox),
                                                }}/>

                                                <HMTextView
                                                    text={i18n.t('constant.Add_video')}
                                                    style={{
                                                        alignSelf: 'center',
                                                        //  marginRight: moderateScale(6),
                                                        // margin: moderateScale(2),
                                                        textAlign: 'center',
                                                        color: Colors.colorDarkText,
                                                        fontSize: moderateScale(28 / SizeBox),
                                                    }}/>
                                                <HMTextView
                                                    text={'(حداکثر اندازه فیلم ' + typeExport.ORGINAL_SIZE_FILE + ' مگابایت )'}
                                                    style={{
                                                        alignSelf: 'center',
                                                        //  marginRight: moderateScale(6),
                                                        marginTop: moderateScale(6),
                                                        textAlign: 'center',
                                                        color: Colors.red,
                                                        fontSize: moderateScale(26 / (SizeBox)),
                                                    }}/>


                                            </TouchableOpacity>
                                    }


                                </View>
                                {/*          </CardItem>
                            </Card>*/}
                            </View>


                        }


                    </View>
                </View>

                <HMModalSelectFiles
                    isVisible={this.state.visibleModal}

                    arrImageFunc={(path) => {
                        container?.state.arrImage.push(path);
                    }}
                    onShow={this.onShow}
                    hiddenModal={() => this.hiddenModal()}
                    setDataFunc={this.setData}
                    _setStateData={this._setStateData}
                    _setStateDataParent={this.props._setStateData}
                    clearState={this.clearState}
                    fileSelect={this.fileSelect}

                />


            </View>
        );
    }

    _setStateData(object, func) {
        container.setState(object, func);
    }

    fileSelect = async (event, type) => {
        // console.log('@@@@event', event.target?.accept?.length > 30);
        // NavigationService.BackTo(2)

        // this.uploadFile(image, true)

        var checkFile = event.target?.accept?.length > 30;

        let d = checkFile ? 'pathFile' : (type ? 'pathVideo' : 'pathImage');
        let ShowVideo = !checkFile && type ? 'ShowVideo' : null;
        let path = type ? (event._pathVideo ? event._pathVideo : event.target.files[0]) : (checkFile ? event.target.files[0] : await Tools.resizeFile(event.target.files[0]));
        if (checkFile) {
            container.state.arrFile.push(path);
            container.props._setStateData?.({arrFile: this.state.arrFile});
            container.props._setStateDataParent?.({arrFile: this.state.arrFile});

        }
        else if (!type) {
            container.state.arrImage.push(path);
            container.props._setStateData?.({arrImage: this.state.arrImage});
            container.props._setStateDataParent?.({arrImage: this.state.arrImage});

        }
        // else {
        //     this.props._setStateData?.({pathVideo: path})
        //     this.props._setStateDataParent?.({pathVideo: path})
        //
        //     //  this.props.func("pathVideo", path)
        // }
        let obj = {
            //ShowImage:true
            visibleModal: '',
            [d]: path,
            [ShowVideo]: !!type,
            //ShowVideo: type,
            showMessageInput: true,
        };
        container.props._setStateData?.(obj);
        container.props._setStateDataParent?.(obj);
        container.setState(obj,

            () => {

            },
        );
    };
}
